module.exports = __webpack_public_path__ + "static/img/logo-square.710e1e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo-square.png
// module id = heoG
// module chunks = 0